import styled from 'styled-components'

import checkboxActive from 'images/checkboxActive.svg'
import checkbox from 'images/checkbox.svg'

export const Container = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	align-self: center;
`

interface CheckboxIconProps {
	checked: boolean
}

export const CheckboxIcon = styled.img.attrs(({ checked }: CheckboxIconProps) => ({
	src: checked
		? checkboxActive
		: checkbox,
}))<CheckboxIconProps>`
	margin-right: 14px;
`
